'use strict'

const UNKNOWN_VERSION = 'unknown'
const isValidVersionString = version => /^\d+\.\d+\.\d+$/.test(version)

const parseAppUrl = url => {
  const split = url.split('/')
  const possibleArtifact = split[split.length - 3]
  const possibleVersion = split[split.length - 2]
  if (!isValidVersionString(possibleVersion)) {
    throw Error(`Invalid version string ${possibleVersion}`)
  }
  return {
    appName: possibleArtifact,
    version: possibleVersion
  }
}

const getAppNameWithVersion = url => {
  try {
    const { appName, version } = parseAppUrl(url)
    return `${appName}@${version}`
  } catch (e) {
    return UNKNOWN_VERSION
  }
}

const getAppVersion = url => {
  try {
    const { version } = parseAppUrl(url)
    return version
  } catch (e) {
    return UNKNOWN_VERSION
  }
}

module.exports = getAppNameWithVersion
module.exports.getAppVersion = getAppVersion
module.exports.UNKNOWN_VERSION = UNKNOWN_VERSION
